import { Component, OnInit } from '@angular/core'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

import { BusinessPlanSummaryComponent } from '../../admin/business-plan-sections/business-plan-summary.component'
import { BaseComponent, BusinessPlanSection, FeatureType } from '../../shared'

@Component({
    selector: 'app-business-plan',
    templateUrl: './business-plan.component.html',
    styleUrls: ['./business-plan.component.css'],
    standalone: true,
    imports: [BusinessPlanSummaryComponent, FaIconComponent],
})
export class BusinessPlanComponent extends BaseComponent implements OnInit {
    faPrint = faPrint

    sections: BusinessPlanSection[] = []

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.MeetingsBusinessPlanEdit])
    }

    ngOnInit() {
        this.loadBusinessPlanSections()
    }

    loadBusinessPlanSections() {
        this.cancelableRequest(
            'loadBusinessPlanSections',
            true,
            this.services.data.load(true, true, this.services.data.businessPlanSections.queryAll()).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.sections = result[0]
                },
                error: error => {
                    this.services.notification.error('Failed to load business plan sections')
                    console.error('Error loading business plan sections:', error)
                },
            }),
        )
    }

    printDocument() {
        window.print()
    }
}
